import { useContext, useState } from "react";
import authContext from "../../context/auth/authContext";
import { validate2fa } from "../action/login2fa/validate2fa";
import { sendEmailHelp } from "../action/login2fa/sendEmailHelp";
import { resendEmailValidation } from "../action/login2fa/resendEmailValidation";

export const Login2fa = ({ tempToken, setMessage, isRequired, setIsRequired, dispatch, tmpData }) => {
  const AuthContext = useContext(authContext);
  const { iniciarSesion } = AuthContext;
  const [code2fa, setcode2fa] = useState('');
  const [timeLeft, setTimeLeft] = useState(60);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isHelpDisabled, setIsHelpDisabled] = useState(false);

  // Maneja el envío del formulario de verificación en dos pasos (2FA).
  const handleSubmit2fa = (e) => {
    e.preventDefault();
    if (isFormValid2fa()) {
      dispatch(validate2fa(tempToken, code2fa, tmpData, dispatch, iniciarSesion));
    }
  }

  // Maneja el reenvío del correo electrónico de validación 2FA. Desactiva temporalmente el botón, inicia un temporizador de 60 segundos para reactivar el botón
  const resendEmail = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    if (!isDisabled) {
      dispatch(resendEmailValidation(tmpData));
      let totalTime = 60;

      const intervalId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      setTimeout(() => {
        clearInterval(intervalId);
        setIsDisabled(false);
        setTimeLeft(totalTime);
      }, totalTime * 1000);
    }
  }

  // Valida si el formulario de inicio de sesión está correctamente completado.
  const isFormValid2fa = () => {
    let isValid2fa = true;
    if (code2fa.trim().length === 0) {
      setMessage('Favor de introducir código de verificación');
      setIsRequired(true);
      isValid2fa = false;
    }
    return isValid2fa;
  }

  // Envía una solicitud de ayuda por correo electrónico.
  const sendHelp = () => {
    setIsHelpDisabled(true);
    if (!isHelpDisabled) {
      dispatch(sendEmailHelp(tmpData));
    }
  }

  return (
    <>
      <div className="row justify-content-center">
        <strong className='text-muted'>Código de verificación</strong>
        <input
          style={{ textTransform: 'uppercase', textAlign: 'center' }}
          type='text'
          autoComplete="off"
          className={isRequired ? "col-10 required" : "col-10"}
          name="in-code_2fa"
          id="in-code_2fa"
          maxLength={6}
          onChange={(e) => setcode2fa(e.target.value)}
          placeholder=""
        />
      </div>
      <div className="row justify-content-center py-3">
        <button type="submit" className="btn col-10" id="logIn" onClick={handleSubmit2fa}>
          Entrar
        </button>
        {
          <button type="button" className="btn col-10 mt-1" id="reSend" disabled={isDisabled} onClick={resendEmail} >
            Reenviar código
          </button>
        }
        {
          (isDisabled) &&
          <p style={{ marginTop: '10px' }}>
            Reenviar código en: {timeLeft} segundo(s)
          </p>
        }
      </div>
      <div className='text-center'>
        <button type="button" className="btn col-10 mt-1" id="sendHelp" disabled={isHelpDisabled} onClick={sendHelp} >
          <small>¿Necesitas ayuda?</small>
        </button>
      </div>
    </>
  )
}